import { useEffect } from 'react'
import { Box } from '@mui/material'
import { theme } from '@pagopa/mui-italia'
import { AppSkeleton } from '@lucan/base-ui'
import { ROTTA_BASE_API, URL_SERVER, OPERAZIONI, ENTITA, OPERAZIONI_BASE_CONFIG, getAttachmentURLCustom } from 'configuration/ConfigurazioneApi'
import { ELENCHI_CONFIG } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES, ROUTES_SENZA_COMANDO, ROUTES_NON_LOGGATO } from 'configuration/ConfigurazioneRotte'
import { LinguaProvider } from 'context/LinguaProvider'
import { SessioneProvider } from 'context/SessioneProvider'
import { TemaProvider } from 'components/ui/TemaProvider'
import UrlSwitchContextProvider from 'context/UrlSwitchContextProvider'
import { useAppContext } from 'GlobalContext'
import SceltaLingua from 'components/ui/SceltaLingua'
import Home from 'pages/Home'

const URL_SSO_LOGIN = process.env.REACT_APP_URL_SSO_LOGIN
const URL_SSO = process.env.REACT_APP_URL_SSO

export default function App() {
  const { lingua, cmd } = useAppContext()

  return (
    <AppSkeleton
      // Rotte
      //propsRouteHome={{pathRelativo:"/staff", pathAssoluto: '/staff',}}
      CHIAVI_ROUTES={CHIAVI_ROUTES}
      ROUTES_NON_LOGGATO={ROUTES_NON_LOGGATO}
      ROUTES_SENZA_COMANDO={[...ROUTES_SENZA_COMANDO,...ROUTES_NON_LOGGATO]}
      //homeSenzaComando={<Home />}
      MainAppProvider={MainAppProvider}
      URL_SSO_LOGIN={URL_SSO_LOGIN}
      URL_SSO={URL_SSO}

      // Api
      ROTTA_BASE_API={ROTTA_BASE_API}
      URL_SERVER={URL_SERVER}
      OPERAZIONI={OPERAZIONI}
      OPERAZIONI_CONFIG={OPERAZIONI_BASE_CONFIG}
      ENTITA={ENTITA}

      propsApiRequestProvider={{ getAttachmentURLCustom }}

      // Elenchi
      ELENCHI_CONFIG={ELENCHI_CONFIG}
      propsElenchiProvider={{ infoAggiuntivePromessa: { lingua, cmd } }}

      // Altro
      nomeApp='link'
      titoloApp='Link'
      dataBuild={process.env.REACT_APP_DATA_BUILD}
      versione={process.env.REACT_APP_GIT_COMMIT_ID}
      mostraRibbonAlfa={process.env.REACT_APP_ENV_NAME !== 'prod'}
      theme={theme}
      nascondiScheletro
    />
  )
}



function MainAppProvider(props) {
  const { children } = props
  const { lingue, uri } = useAppContext()

  useEffect(() => {
    const loader = document.getElementById('app-loader')
    if (loader) loader.remove()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {uri &&
        <LinguaProvider>
          <SessioneProvider>
            <TemaProvider>
              <UrlSwitchContextProvider>
                <Box sx={{ bgcolor: '#fff', boxShadow: 3 }}>
                  {lingue?.length > 1 &&
                    <Box sx={{ position: 'absolute', right: 0, pr: 1 }}>
                      <SceltaLingua lingue={lingue} sx={{ position: 'relative', bottom: 8 }} />
                    </Box>
                  }
                  {children}
                </Box>
              </UrlSwitchContextProvider>
            </TemaProvider>
          </SessioneProvider>
        </LinguaProvider>
      }
    </>
  )
}
